import { createRouter, createWebHashHistory } from 'vue-router'
const routes = [
  {
    path: '/zh/protocol', // 用户协议-中文
    component: () => import('../views/newLife/newLifeZh')
  },
  {
    path: '/la/protocol', // 用户协议-老文
    component: () => import('../views/newLife/newLifeLao')
  },
  {
    path: '/zh/privacy', // 隐私协议-中文
    component: () => import('../views/newLife/privacyZh')
  },
  {
    path: '/la/privacy', // 隐私协议-老文
    component: () => import('../views/newLife/privacyLao')
  },
  {
    path: '/zh/platform', // 平台服务-中文
    component: () => import('../views/newLife/platformZh')
  },
  {
    path: '/la/platform', // 平台服务-老文
    component: () => import('../views/newLife/platformLao')
  },
  {
    path: '/zh/cancel', // 用户注销说明-中文
    component: () => import('../views/newLife/cancelZh')
  },
  {
    path: '/la/cancel', // 用户注销说明-老文
    component: () => import('../views/newLife/cancelLao')
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
